(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-faq-template"]) return;
  try {
    
  (function() {
  if (!__sections__["page-faq-template"]) return;
  try {
    
  (function() {
    $('body').on('click', '.faq__question', function() {
      $(this).next('.faq__answer').slideToggle(150).toggleClass('active');
    $(this).toggleClass('active');
    });

    $(document).on('shopify:block:select', '#shopify-section-page-faq-template', function(event) {
      $(event.target).find('.faq__answer').slideDown(150);
    });

    $(document).on('shopify:block:deselect', '#shopify-section-page-faq-template', function(event) {
      $(event.target).find('.faq__answer').slideUp(150);
    });
  }());

  } catch(e) { console.error(e); }
})();



  } catch(e) { console.error(e); }
})();
})();
